module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isMounted) ? _c('div', [_c('ul', {
    class: _vm.navUlClass,
    attrs: {
      "data-widget": "tree"
    }
  }, [(_vm.showHeader) ? _c('li', {
    staticClass: "header"
  }, [_vm._v("NAVIGATION")]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_c('router-link', {
    attrs: {
      "to": "/",
      "exact": true
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-home"
  }), _vm._v(" Home\n                ")])], 1), _vm._v(" "), _c('li', {
    class: {
      disabled: !_vm.canAccess('Delivery Tickets')
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/deliverytickets"
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-tags"
  }), _vm._v(" Delivery Tickets\n                ")])], 1), _vm._v(" "), _c('li', {
    staticClass: "treeview",
    class: {
      disabled: !_vm.canAccess('Equipment')
    }
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu",
    class: {
      disabled: !_vm.canAccess('Equipment')
    }
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/assets"
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-cog"
  }), _vm._v(" Asset Master\n                ")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/subassemblies"
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-cog"
  }), _vm._v(" Sub-Assembly Master\n                ")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/components"
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-cog"
  }), _vm._v(" Component Master\n                ")])], 1)])]), _c('li', {
    class: {
      disabled: !_vm.canAccess('Equipment Returns')
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/equipmentreturns"
    }
  }, [_c('span', {
    staticClass: "fa fa-truck"
  }), _vm._v(" Equipment Returns\n                ")])], 1), _vm._v(" "), _c('li', {
    class: {
      disabled: !_vm.canAccess('Equipment Service')
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/equipmentservice"
    }
  }, [_c('span', {
    staticClass: "fa fa-shower"
  }), _vm._v(" Equipment Servicing\n                ")])], 1), _vm._v(" "), _c('li', {
    class: {
      disabled: !_vm.canAccess('Assemblies')
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/assetbuilds"
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-cog"
  }), _vm._v(" Asset Build\n                        ")])], 1), _vm._v(" "), _c('li', {
    class: {
      disabled: !_vm.canAccess('Assemblies')
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/subassemblybuilds"
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-cog"
  }), _vm._v(" Sub-Assembly Build\n                        ")])], 1), _vm._v(" "), _c('li', {
    class: {
      disabled: !_vm.canAccess('Delivery Tickets')
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/transfers"
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-transfer"
  }), _vm._v(" Equipment Transfers\n                ")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/reports"
    }
  }, [_c('span', {
    staticClass: "fa fa-list"
  }), _vm._v(" Reports\n                ")])], 1), _vm._v(" "), (_vm.showCustomers) ? _c('li', {
    class: {
      disabled: !_vm.canAccess('Customers')
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/customers"
    }
  }, [_c('span', {
    staticClass: "fa fa-address-book"
  }), _vm._v(" Customers\n                ")])], 1) : _vm._e(), _vm._v(" "), (_vm.showHistory) ? _c('li', {
    class: {
      disabled: !_vm.canAccess('Logs')
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/logs/all/all"
    }
  }, [_c('span', {
    staticClass: "fa fa-history"
  }), _vm._v(" History\n                ")])], 1) : _vm._e(), _vm._v(" "), (_vm.showUserAccounts) ? _c('li', {
    staticClass: "treeview",
    class: {
      disabled: !_vm.canAccess('User Accounts')
    }
  }, [_vm._m(1), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/accounts"
    }
  }, [_c('span', {
    staticClass: "fa fa-list"
  }), _vm._v(" Account List\n                ")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/register-account"
    }
  }, [_c('span', {
    staticClass: "fa fa-user-plus"
  }), _vm._v(" Register User\n                ")])], 1)])]) : _vm._e(), (_vm.showLookups) ? _c('li', {
    staticClass: "treeview",
    class: {
      disabled: !_vm.canAccess('Lookups')
    }
  }, [_vm._m(2), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/parts"
    }
  }, [_c('span', {
    staticClass: "fa fa-database"
  }), _vm._v(" Parts\n                        ")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/equipmentclasses"
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-list-alt"
  }), _vm._v(" Equipment Classes\n                        ")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/operators"
    }
  }, [_c('span', {
    staticClass: "fa fa-hospital-o"
  }), _vm._v(" Operators\n                        ")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/truckingcompanies"
    }
  }, [_c('span', {
    staticClass: "fa fa-truck"
  }), _vm._v(" Trucking Companies\n                        ")])], 1), _vm._v(" "), _vm._l((_vm.lookups), function(item) {
    return _c('li', [_c('router-link', {
      attrs: {
        "to": item.indexPath
      }
    }, [_c('span', {
      staticClass: "glyphicon glyphicon-list-alt"
    }), _vm._v(" " + _vm._s(item.title) + "\n                        ")])], 1)
  })], 2)]) : _vm._e()])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-link"
  }), _vm._v(" "), _c('span', [_vm._v("Equipment")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-left pull-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-link"
  }), _vm._v(" "), _c('span', [_vm._v("User Accounts")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-left pull-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-link"
  }), _vm._v(" "), _c('span', [_vm._v("Lookups")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-left pull-right"
  })])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7cdbf41a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7cdbf41a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./ClientApp/components/nav-menu/nav-menu.vue.html
// module id = 1120
// module chunks = 0